import {
  calculateDayProgressPercentage,
  calculateDaysLeft,
  calculateTotalDurationInMonths,
} from '../../../utils/timeAndDate';

const RetainProgressBar = ({
  startingDate,
  endingDate,
}: {
  startingDate: string;
  endingDate: string;
}) => {
  // rendering retain progress bar component here
  return (
    <div>
      <div className='flex items-center justify-between text-xs font-semibold text-base-light-blue px-1'>
        <div>
          <p className='italic'>Starting Date</p>
          <p>{startingDate}</p>
        </div>

        <div className='text-center'>
          <p className='italic'>Total Duration</p>
          <p>
            {calculateTotalDurationInMonths(startingDate, endingDate)} Months
          </p>
        </div>

        <div className='text-right'>
          <p className='italic'>Ending Date</p>
          <p>{endingDate}</p>
        </div>
      </div>

      <div className='h-2 w-full bg-base-light-blue/20 rounded-full overflow-hidden'>
        <div
          style={{
            width: `${calculateDayProgressPercentage(
              startingDate,
              endingDate
            )}%`,
          }}
          className='h-full bg-base-light-blue rounded-full'
        />
      </div>

      <div className='text-center text-sm font-semibold text-base-light-blue'>
        <p>{calculateDaysLeft(endingDate)} days left</p>
      </div>
    </div>
  );
};

export default RetainProgressBar;
